<div class="stationContainer">
	<div class="stationSelector">
		@if (stations().length) {
			<label class="secondary">{{ T.LABEL_STATIONS | translate }}</label>
			<ul #stationList>
				<sim-chevron-overflow>
					@for (station of stations(); track station.id) {
						<li>
							<button
								#stationBtn
								class="stationFab"
								matRipple
								[class.selected]="activeStationIndex() === $index"
								(click)="activeStationIndex.set($index)"
							>
								{{ $index + 1 }}
							</button>
							@if (!$last && stations().length > 1) {
								<div class="separator">
									<span></span>
									<span></span>
								</div>
							}
						</li>
					}
				</sim-chevron-overflow>
			</ul>
		} @else {
			<span class="secondary">{{ T.SESSION_STATION_PREVIEW_NO_STATIONS | translate }}</span>
		}
	</div>
	<div class="stationWrapper">
		<mat-tab-group [selectedIndex]="activeStationIndex()">
			@for (station of stations(); track station.id) {
				<mat-tab>
					<div class="stationCard">
						<!--INDEX INDICATOR-->
						<div class="indexIndicator background">
							{{ $index + 1 }}
						</div>
						<!--CHAIN LINK-->
						<div class="chainLink">
							<div class="top background"></div>
							<div class="bottom background"></div>
						</div>
						<!--CONTENT-->
						<div class="cardContent background">
							<ng-container *ngTemplateOutlet="contentTemplate(); context: {$implicit: {station: station, index: $index}}" />
						</div>
					</div>
				</mat-tab>
			}
		</mat-tab-group>
	</div>
</div>
